(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[820],{

/***/ 21711:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_error",
      function () {
        return __webpack_require__(83215);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 41001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* reexport */ Button; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/ui/Loader/index.ts + 2 modules
var Loader = __webpack_require__(67022);
// EXTERNAL MODULE: ./components/ui/Typography/index.ts + 2 modules
var Typography = __webpack_require__(59253);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50445);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 7 modules
var polished_esm = __webpack_require__(95044);
// EXTERNAL MODULE: ./styles/mixins/indent/indent.ts
var indent = __webpack_require__(81);
;// CONCATENATED MODULE: ./components/ui/Button/styles.ts



function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  border: 1px solid;\n  transition: 0.3s ease;\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  .button-typography {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  .button-typography {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  pointer-events: none;\n  cursor: not-allowed;\n  border-color: ",
        ";\n  background: ",
        ";\n  .button-typography {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  pointer-events: none;\n  cursor: not-allowed;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  line-height: 1;\n  user-select: none;\n  transition: all 0.3s ease;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  border-radius: 5px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  border-radius: 12px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  border-color: ",
        ";\n  box-shadow: 0 8px 10px ",
        ",\n    0 3px 14px ",
        ", 0 4px 5px ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  border-color: ",
        ";\n  box-shadow: none;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n        border: none;\n        background: none;\n      "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n      &:hover {\n        ",
        "\n      }\n      &:active {\n        ",
        "\n      }\n    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n        border-color: ",
        ";\n        background-color: ",
        ";\n        ",
        "\n      "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n      border-color: ",
        ";\n      background-color: ",
        ";\n      ",
        "\n    "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  width: ",
        ";\n  ",
        "\n  ",
        "\n  ",
        "\n  \n  &:hover {\n    ",
        "\n  }\n\n  &:active {\n    ",
        "\n  }\n\n  &[disabled] {\n    ",
        "\n  }\n\n  ",
        "\n\n  .button-typography {\n    ",
        "\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n      visibility: hidden;\n      opacity: 0;\n    "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  transition: all 0.3s ease;\n\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n      visibility: visible;\n      opacity: 1;\n    "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  transition: all 0.3s ease;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  visibility: hidden;\n  opacity: 0;\n\n  ",
        "\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
var coreButtonStyles = function() {
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject());
};
var hoverButtonStyles = function() {
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), function(param) {
        var theme = param.theme;
        return theme.palette.text.ALTERNATIVE;
    });
};
var activeButtonStyles = function() {
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), function(param) {
        var theme = param.theme;
        return theme.palette.text.ALTERNATIVE;
    });
};
var disabledButtonStyles = function(fill) {
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), function(param) {
        var theme = param.theme;
        return theme.palette.core.LIGHT_GRAY;
    }, function(param) {
        var theme = param.theme;
        return fill === 'outlined' ? theme.palette.core.TRANSPARENT : theme.palette.core.LIGHT_GRAY;
    }, function(param) {
        var theme = param.theme;
        return fill === 'outlined' ? theme.palette.text.DEEP_GRAY : theme.palette.text.ALTERNATIVE;
    });
};
var loadingButtonStyles = function() {
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject4());
};
var typographyStyles = function() {
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject5());
};
var flatVariantStyles = function() {
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject6(), (0,indent/* indent */.W)('padding', {
        vertical: 8.5,
        horizontal: 35
    }));
};
var regularVariantStyles = function(size) {
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject7(), (0,indent/* indent */.W)('padding', {
        top: size === 'sm' ? 8 : 14,
        left: size === 'xl' ? 58 : 30,
        right: size === 'xl' ? 58 : 30,
        bottom: size === 'sm' ? 8 : 14
    }));
};
var textVariantStyles = function() {
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject8());
};
var hoverStyles = function(hoverColor) {
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject9(), hoverColor, hoverColor, (0,polished_esm/* transparentize */.DZ)(0.86, hoverColor), (0,polished_esm/* transparentize */.DZ)(0.88, hoverColor), (0,polished_esm/* transparentize */.DZ)(0.8, hoverColor));
};
var activeStyles = function(hoverColor) {
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject10(), (0,polished_esm/* lighten */.$n)(0.1, hoverColor), (0,polished_esm/* lighten */.$n)(0.1, hoverColor));
};
var Wrapper = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-5c5cb83c-0"
})(_templateObject15(), function(param) {
    var width = param.width;
    return width ? "".concat(width, "px") : 'auto';
}, coreButtonStyles(), function(param) {
    var variant = param.variant, size = param.size;
    if (variant === 'flat') return flatVariantStyles();
    if (variant === 'text') return textVariantStyles();
    return regularVariantStyles(size);
}, function(param) {
    var fill = param.fill, rawColor = param.color, rawHoverColor = param.hoverColor, theme = param.theme, variant = param.variant;
    if (variant === 'text') return (0,styled_components_browser_esm/* css */.iv)(_templateObject11());
    var color = rawColor || theme.palette[fill === 'outlined' ? 'primary' : 'secondary'].MAIN;
    var hoverColor = rawHoverColor || theme.palette.secondary.MAIN;
    var effects = (0,styled_components_browser_esm/* css */.iv)(_templateObject12(), hoverStyles(hoverColor), activeStyles(hoverColor));
    if (fill === 'outlined') return (0,styled_components_browser_esm/* css */.iv)(_templateObject13(), color, theme.palette.core.TRANSPARENT, effects);
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject14(), color, color, effects);
}, hoverButtonStyles(), activeButtonStyles(), function(param) {
    var fill = param.fill;
    return disabledButtonStyles(fill);
}, function(param) {
    var isLoading = param.isLoading;
    return isLoading && loadingButtonStyles();
}, typographyStyles());
var ButtonContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5c5cb83c-1"
})(_templateObject17(), function(param) {
    var isLoading = param.isLoading;
    return isLoading && (0,styled_components_browser_esm/* css */.iv)(_templateObject16());
});
var LoaderWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5c5cb83c-2"
})(_templateObject19(), function(param) {
    var isLoading = param.isLoading;
    return isLoading && (0,styled_components_browser_esm/* css */.iv)(_templateObject18());
});

;// CONCATENATED MODULE: ./components/ui/Button/component.tsx





function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var getTypographyColor = function(fill, theme, textColor) {
    if (textColor) return textColor;
    return fill === 'contained' ? theme.palette.text.ALTERNATIVE : theme.palette.text.MAIN;
};
var Button = function(_param) {
    var children = _param.children, _fill = _param.fill, fill = _fill === void 0 ? 'contained' : _fill, _variant = _param.variant, variant = _variant === void 0 ? 'regular' : _variant, _size = _param.size, size = _size === void 0 ? 'default' : _size, textColor = _param.textColor, _isLoading = _param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, color = _param.color, _type = _param.type, type = _type === void 0 ? 'button' : _type, props = _objectWithoutProperties(_param, [
        "children",
        "fill",
        "variant",
        "size",
        "textColor",
        "isLoading",
        "color",
        "type"
    ]);
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var typographyColor = getTypographyColor(fill, theme, textColor);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, _objectSpread({
        fill: fill,
        variant: variant,
        size: size,
        isLoading: isLoading,
        color: color,
        type: type
    }, props, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonContent, {
                isLoading: isLoading,
                children: [
                    typeof children === 'string' && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        className: "button-typography",
                        color: typographyColor,
                        typography: theme.typography.variants.button.MAIN,
                        title: children,
                        children: children
                    }),
                    typeof children !== 'string' && children
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderWrapper, {
                isLoading: isLoading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {
                    color: typographyColor
                })
            })
        ]
    })));
};


;// CONCATENATED MODULE: ./components/ui/Button/index.ts



/***/ }),

/***/ 67022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* reexport */ Loader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/ui/Icon/index.ts + 3 modules
var Icon = __webpack_require__(37033);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50445);
// EXTERNAL MODULE: ./styles/theme/palette/index.ts + 1 modules
var palette = __webpack_require__(42389);
// EXTERNAL MODULE: ./utilities/pixelize/pixelize.ts
var pixelize = __webpack_require__(60548);
;// CONCATENATED MODULE: ./components/ui/Loader/styles.ts


function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: ",
        ";\n  height: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-be77b84a-0"
})(_templateObject(), function(param) {
    var size = param.size;
    return (0,pixelize/* pixelize */.P)(size);
}, function(param) {
    var size = param.size;
    return (0,pixelize/* pixelize */.P)(size);
});

;// CONCATENATED MODULE: ./components/ui/Loader/component.tsx





var Loader = function(param) {
    var _size = param.size, size = _size === void 0 ? 48 : _size, _color = param.color, color = _color === void 0 ? palette/* palette.Core.WHITE */.D.QY.WHITE : _color;
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        size: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
            icon: theme.icons.loader.Loader,
            size: size,
            color: color
        })
    }));
};

;// CONCATENATED MODULE: ./components/ui/Loader/index.ts



/***/ }),

/***/ 83215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _error; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@sentry/minimal/esm/index.js
var esm = __webpack_require__(39666);
// EXTERNAL MODULE: ./components/ui/Box/index.ts + 2 modules
var Box = __webpack_require__(97243);
// EXTERNAL MODULE: ./components/ui/Button/index.ts + 2 modules
var Button = __webpack_require__(41001);
// EXTERNAL MODULE: ./components/ui/Flex/index.ts + 8 modules
var Flex = __webpack_require__(69029);
// EXTERNAL MODULE: ./components/ui/Icon/index.ts + 3 modules
var Icon = __webpack_require__(37033);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(51759);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50445);
// EXTERNAL MODULE: ./components/ui/Typography/index.ts + 2 modules
var Typography = __webpack_require__(59253);
;// CONCATENATED MODULE: ./components/pages/ErrorPage/styles.ts


function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  height: 100vh;\n  max-width: 660px;\n  margin: auto;\n  padding: 0 16px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n\n  button {\n    width: max-content;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 48px;\n  font-weight: bold;\n  letter-spacing: -0.04em;\n  color: rgb(30 54 86 / 50%);\n\n  @media screen and (max-width: 768px) {\n    font-size: 36px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  line-height: 130%;\n  letter-spacing: -0.04em;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8e0a4a5c-0"
})(_templateObject());
var StyledTypographyTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* Typography */.Z).withConfig({
    componentId: "sc-8e0a4a5c-1"
})(_templateObject1());
var StyledTypographyDescription = (0,styled_components_browser_esm/* default */.ZP)(Typography/* Typography */.Z).withConfig({
    componentId: "sc-8e0a4a5c-2"
})(_templateObject2());

;// CONCATENATED MODULE: ./components/pages/ErrorPage/component.tsx









var ErrorPage = function(param) {
    var statusCode = param.statusCode;
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var router = (0,next_router.useRouter)();
    var t = (0,useTranslation/* default */.Z)('error').t;
    var handleButtonClick = function() {
        return void router.push('/');
    };
    var renderErrorTemplate = function() {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: statusCode === 500 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                "data-testid": "server-error-template",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        marginBottom: 20,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTypographyTitle, {
                            children: t('server-error.title')
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTypographyDescription, {
                        color: theme.palette.core.DEEP_GRAY,
                        children: t('server-error.description')
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                "data-testid": "not-found-error-template",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        marginBottom: 20,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTypographyTitle, {
                            children: t('not-found-error.title')
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTypographyDescription, {
                        color: theme.palette.core.DEEP_GRAY,
                        children: t('not-found-error.description')
                    })
                ]
            })
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
            container: true,
            direction: "column",
            alignItems: "center",
            rowGap: 40,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                    container: true,
                    direction: "column",
                    justify: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                            marginBottom: 28,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                fill: theme.palette.core.WHITE,
                                icon: theme.icons.core.Error
                            })
                        }),
                        renderErrorTemplate()
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    onClick: handleButtonClick,
                    variant: "flat",
                    fill: "outlined",
                    "data-testid": "link-btn",
                    children: t('btnText')
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./components/pages/ErrorPage/index.ts


;// CONCATENATED MODULE: ./pages/_error.tsx



var MyError = function(param) {
    var statusCode = param.statusCode, hasGetInitialPropsRun = param.hasGetInitialPropsRun, err = param.err;
    if (!hasGetInitialPropsRun && err) {
        // getInitialProps is not called in case of
        // https://github.com/vercel/next.js/issues/8592. As a workaround, we pass
        // err via _app.js so it can be captured
        esm/* captureException */.Tb(err);
    // Flushing is not required in this case as it only happens on the client
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage, {
        statusCode: statusCode
    }));
};
var __N_SSP = true;
/* harmony default export */ var _error = (MyError);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(21711); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);